const sortPagesByCateg = (pages) => {
  const result = {};

  pages.forEach(({ title, keyword }) => {
    const breadcrumbs = keyword.split('/');
    const categ = breadcrumbs[1];

    const page = {
      name: title,
      path: keyword,
    };

    if (!result[categ]) {
      result[categ] = {};
    }

    if (breadcrumbs.length === 2) {
      result[categ].title = title;
      return;
    }

    if (result[categ].links) {
      result[categ].links.push(page);
      return;
    }

    result[categ].links = [page];
  });

  return result;
};

export default sortPagesByCateg;



// WEBPACK FOOTER //
// ./src/shared/utils/helpers/sortPagesByCateg.js